// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2 small[data-v-2c965b04]{color:var(--color-warning);border:1px solid var(--color-warning);border-radius:16px;padding:0 9px}h2 small .icon[data-v-2c965b04]{width:16px;height:16px;margin-bottom:4px}p[data-v-2c965b04]{display:block;align-items:center}p .icon[data-v-2c965b04]{width:16px;height:16px}p label[data-v-2c965b04]{display:block;margin-right:10px}\n", ""]);
// Exports
module.exports = exports;
